import styled from "styled-components";
import {
  PRIMARY_LIGHT_RED,
  PRIMARY_RED,
  SECONDARY_RED,
} from "../../constants/color";
import { AlertIcon } from "./icons/AlertIcon";

export const Alert: React.FC = () => {
  return (
    <StyledAlertContainer>
      <StyledAlertContent>
        <StyledAlertHeader>
          <AlertIcon />
          <StyledAlertTitle>データエラー</StyledAlertTitle>
        </StyledAlertHeader>

        <StyledAlertDetail>
          <div>・</div>
          アップロードファイルに問題があります。ファイルを修正し、再度アップロードしてください。エラーの詳細はファイルをダウンロードし、ご確認ください
        </StyledAlertDetail>
      </StyledAlertContent>
    </StyledAlertContainer>
  );
};

const StyledAlertContainer = styled.div`
  display: flex;
  padding: 12px 35px 15px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 2px solid ${SECONDARY_RED};
  background: ${PRIMARY_LIGHT_RED};
`;

const StyledAlertContent = styled.div``;

const StyledAlertHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const StyledAlertTitle = styled.div`
  color: ${PRIMARY_RED};
  font-size: 20px;
  font-weight: 700;
  line-height: 200%;
`;

const StyledAlertDetail = styled.div`
  display: flex;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
`;
